import React from 'react';
import LayerData from './layer-data';
import FrameList from './frame-list';
import './stage-editor.css';

/** @class AnimationLayerData
  * A component for editing animation layer-specific properties.
  */
export default class AnimationLayerData extends LayerData {
  /** @function render
    * Renders the component.
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Animation Layer</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text" name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="x">X position</label><br/>
          <input type="number" name="x"
            value={this.state.x}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="x">Y position</label><br/>
          <input type="number" name="y"
            value={this.state.y}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="name">Frames Per Second</label><br/>
          <input type="text" name="framesPerSecond"
            value={this.state.framesPerSecond}
            onChange={this.handleNumberChange}
            onBlur={this.handleBlur}
            />
        </div>
        <FrameList dataURL={this.props.dataURL + '/frames'} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stage-editor/animation-layer-data.js